import { type OddsFormat } from '@cx-web/domain-types';

export function getOddsByFormat(
  bet: {
    oddsAmerican: string;
    oddsDecimal: number;
    oddsFractional: string;
  },
  format: OddsFormat,
): string {
  switch (format) {
    case 'decimal':
      return bet.oddsDecimal.toFixed(2);
    case 'fractional':
      return bet.oddsFractional;
    default:
      return bet.oddsAmerican;
  }
}
